/* eslint-disable */
import envGet from '../Get/EnvGet.support';

/**
 * Determine if we are in the `test` environment
 * @export
 * @returns {boolean} Whether or not we are in test
 */
const envIsTest = () => envGet({ key: `REACT_APP_ENV` }) === `test`;

export default envIsTest;
